export default __webpack_public_path__ + "static/media/a009-3.608ee07f.svg";